<template>
  <div class="view">
    <el-row>
      <el-col :span="6">店铺名称</el-col>
      <el-col :span="18">{{data.name}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">店铺编号</el-col>
      <el-col :span="18">{{data.number}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">省市县/区域</el-col>
      <el-col :span="18">{{data.provinceName+'/'+data.cityName+'/'+data.districtName+'/'+data.regionName}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">地址</el-col>
      <el-col :span="18">{{data.address}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">店老板姓名</el-col>
      <el-col :span="18">{{data.ownerName}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">店老板手机</el-col>
      <el-col :span="18">{{data.ownerPhone}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">负责人姓名</el-col>
      <el-col :span="18">{{data.managerName}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="6">负责人手机</el-col>
      <el-col :span="18">{{data.managerPhone}}</el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :data="data.staffList"
          max-height="400"
          border
          stripe>
          <el-table-column
            prop="customerName"
            label="店员姓名"
            width="150">
          </el-table-column>
          <el-table-column
            prop="phoneNumber"
            label="手机号">
          </el-table-column>
          <el-table-column
            prop="typeName"
            label="职责权限">
          </el-table-column>
          <el-table-column
            prop="created"
            label="注册时间">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'ShopView',
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.view
  padding: 0

</style>



// WEBPACK FOOTER //
// src/components/ShopView.vue